import { render, staticRenderFns } from "./Public.vue?vue&type=template&id=c45daa14&scoped=true"
import script from "./Public.vue?vue&type=script&lang=js"
export * from "./Public.vue?vue&type=script&lang=js"
import style0 from "./Public.vue?vue&type=style&index=0&id=c45daa14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45daa14",
  null
  
)

export default component.exports